const loader = document.getElementById('page-loader');

if (loader) {
  const minimumDuration = 2150;
  const startedAt = performance.now();

  document.documentElement.classList.add('page-loader-active');

  const finishLoader = () => {
    const remainingDuration = Math.max(
      0,
      minimumDuration - (performance.now() - startedAt)
    );

    window.setTimeout(() => {
      loader.classList.add('is-finished');
      document.documentElement.classList.remove('page-loader-active');

      window.setTimeout(() => loader.remove(), 300);
    }, remainingDuration);
  };

  if (document.readyState === 'complete') {
    finishLoader();
  } else {
    window.addEventListener('load', finishLoader, { once: true });
  }
}
